export default "__VITE_ASSET__E9HEew8V__"